/**
 * StandYaratPage.jsx — Stand Yarat (denetmen/staff tarafı)
 * Route: /Management/Standlar/Yeni  (eski /Management/Projects/Stands/New yönleniyor)
 * Açan: Standlar listesindeki "Stand Yarat" butonu (2026-09-15'ten beri menüde yok).
 *
 * 2026-09-15 SADELEŞTİRME: üç numaralı kart + "Ne Kaydedilecek" yan paneli + uzun
 * açıklamalar tek bir karta indi. Ad ön izlemesi alt çubukta, mock-fuar uyarısı başlıkta
 * küçük bir rozet. Mantık (zincir, öneri, yazma sırası) DEĞİŞMEDİ.
 *
 * Zincir — tek "Standı Oluştur" butonu, sırayla dört uç:
 *   POST /standTalep/create              → `stand` + `salon_stand_firma_to_fuar` (firma_id=0)
 *   PUT  /standTalep/update/{standId}    → yalnızca tabela adı varsa (create bu alanı ALMIYOR)
 *   POST /standTalep/assignFirma/{id}    → katılımcı (zorunlu) + dekoratör (opsiyonel), İKİ ayrı çağrı
 *   POST /project (projectService)       → opsiyonel proje kabuğu, kök stand tipi seçildiyse
 *
 * ⚠️ ADI SUNUCU KURUYOR (2026-09-03). Form "Hol No" SORMUYOR: gönderilen şey
 * `standCode` (holün içindeki kod, örn. "A10") ve tam ad `{salon_name}.{kod}` olarak
 * sunucuda kuruluyor. Bkz. services/standNaming.js ve
 * docs/guides/FE-StandTalepController-guide.md → "Stand naming".
 *
 * ⚠️ TABELA ADI KATILIMCI FİRMANIN KISA ADINDAN ÖNERİLİYOR — kullanıcı alana
 * dokunmadığı sürece. Firma "kısa ad"ı zaten standın üzerinde görünen ada en yakın
 * alan (`firma_shortname`); tüzel unvan (`firma_name`) değil. Kullanıcı yazdığı anda
 * öneri susar ve bir daha ezmez. Kısa adı olmayan firmada alan BOŞ kalır — tabelaya
 * "…SANAYİ VE TİCARET A.Ş." yazdırmaktansa boş bırakmak doğru.
 *
 * ⚠️ Proje kaydı adımı bilerek OPSİYONEL — atlanırsa aynı iş stand detayındaki
 * "Proje Kaydı Oluştur" kartından da yapılabilir. Yükseklik burada SORULMAZ:
 * dekoratör Proje Beyanı'nda beyan eder (bkz. FE-ProjectController-beyani-revisions-guide.md §A).
 *
 * ⚠️ Buradaki firma ataması DOĞRUDAN yoldur (admin aracı, sunucuda yetki kontrolü
 * yok). Stand tarafının serbest metinle açtığı eşleştirme TALEPLERİ ayrı bir akıştır
 * ve Stand Listesi'ndeki "Stand Düzenle" popup'ında yaşar — yeni bir standın henüz
 * talebi olamaz.
 */
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Container, Card, CardBody, CardHeader, CardFooter, Row, Col, Button,
  Label, Alert, Spinner, Badge,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import MainContext from "../../../Components/Contexts/MainContext";
import StandIdentityFields from "../../../Components/Projects/StandIdentityFields";
import { StandTypeRows } from "../../../Components/Projects/StandTypeAgaclari";
import FirmaSearchSelect from "../../../Components/Firma/FirmaSearchSelect";
import CreateFirmaModal from "../../../Components/Firma/CreateFirmaModal";
import { FIRMA_TYPE } from "../../../services/firmaAramaService";
import {
  createStand, updateStand, assignFirmaToStand, getSalonOptions,
} from "../../../services/standOverviewService";
import { getStandTypes, createProject } from "../../../services/projectService";
import { composeStandName, isStandAdiCakismasi } from "../../../services/standNaming";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n";

const LIST_PATH = "/Management/Standlar";

// Canlı backend'e sahip test fuarları — bkz. StandListPage.jsx'teki aynı desen.
// WAS (until #398): only the two seeded test fairs ran on the real backend, every other fair fell back to mock data:
// const LIVE_TEST_FUAR_IDS = [298, 299];
// const isLiveTestFuarId = (fuarId) => LIVE_TEST_FUAR_IDS.includes(Number(fuarId));
// #398: a full-simulation test creates a NEW fair, so every real fair id is live.
const isLiveTestFuarId = (fuarId) => Number(fuarId) > 0;

// WAS (until #398): every new live stand came pre-attached to Dekoratör firma 49858 (Örnek Yapı A.Ş.) so testfirmamod
// could see it on the Firma side without the real assignment step:
// const DEFAULT_TEST_DEKORATOR_FIRMA_ID = 49858;
// const TEST_DEKORATOR = { firmaId: DEFAULT_TEST_DEKORATOR_FIRMA_ID, firmaName: "Örnek Yapı A.Ş." };
// #398: no pre-attached decorator — the decorator comes from the participant's declaration and the staff assignment.

const EMPTY_FORM = {
  salonId: "", standCode: "", tabelaAdi: "", tabelaAdiTouched: false, standTypeId: "",
};

export default function StandYaratPage() {
  const { t: tx } = useTranslation("projeler");
  const navigate = useNavigate();
  const { selectedFuarId } = useContext(MainContext);
  const fuarId = selectedFuarId;
  const forceLive = isLiveTestFuarId(fuarId);

  const [form, setForm] = useState(EMPTY_FORM);
  const [katilimciFirma, setKatilimciFirma] = useState(null);
  // Dekoratör TÜRETİLMİŞ: `undefined` = kullanıcı henüz seçmedi, o yüzden test
  // fuarında hazır öneri geçerli; kullanıcı seçer ya da temizlerse (null) öneri
  // bir daha dönmez. Bir Effect'te setState yapmamak için böyle — fuar seçimi
  // MainContext'ten geç geldiğinde useState başlatıcısı çalışmış olurdu.
  const [dekoratorSecim, setDekoratorSecim] = useState(undefined);
  const dekoratorFirma = dekoratorSecim !== undefined
    ? dekoratorSecim
    : null; // WAS (until #398): (forceLive ? TEST_DEKORATOR : null)
  const [rootTypes, setRootTypes] = useState([]);
  const [salonOptions, setSalonOptions] = useState([]);
  const [salonsLoaded, setSalonsLoaded] = useState(false);
  // "katilimci" | "dekorator" | null — Yeni Firma popup'ı hangi alan için açıldı
  const [createFirmaFor, setCreateFirmaFor] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  // #547: sunucu "bu holde bu adla stand var" dedi → Stand Kodu kutusu kırmızı, kod ya da hol değişince söner
  const [kodCakisti, setKodCakisti] = useState(false);
  // { standId, standName } — oluşturulduktan sonraki başarı paneli
  const [created, setCreated] = useState(null);

  useEffect(() => { document.title = i18n.t("projeler:standYarat.standYaratFds"); }, []);

  // KURAL: fetch mantığı Effect İÇİNDE, setState yalnızca async geri çağrılarda —
  // react-hooks/set-state-in-effect ihlalini önler (bkz. StandListPage.jsx aynı not).
  useEffect(() => {
    let ignore = false;
    getStandTypes(null, { forceLive })
      .then((list) => { if (!ignore) setRootTypes(list || []); })
      .catch(() => { if (!ignore) setRootTypes([]); });
    return () => { ignore = true; };
  }, [forceLive]);

  useEffect(() => {
    if (!fuarId) return undefined;
    let ignore = false;
    getSalonOptions(fuarId, { forceLive })
      .then((list) => { if (!ignore) { setSalonOptions(list || []); setSalonsLoaded(true); } })
      .catch(() => { if (!ignore) { setSalonOptions([]); setSalonsLoaded(true); } });
    return () => { ignore = true; };
  }, [fuarId, forceLive]);

  function update(patch) {
    if ("standCode" in patch || "salonId" in patch) setKodCakisti(false);
    setForm((f) => ({ ...f, ...patch }));
  }

  /**
   * Katılımcı firma seçildi/temizlendi. Tabela adı ÖNERİSİ burada — bir Effect'te
   * değil: öneri bir kullanıcı eylemine cevaptır, türetilmiş bir durum değil.
   * Kullanıcı alana dokunduysa (tabelaAdiTouched) öneri susar.
   */
  function handleKatilimciChange(firma) {
    setKatilimciFirma(firma);
    setForm((f) => {
      if (f.tabelaAdiTouched) return f;
      return { ...f, tabelaAdi: firma?.firmaShortname || "" };
    });
  }

  const salonName = useMemo(
    () => salonOptions.find((s) => String(s.salonId) === String(form.salonId))?.salonName || "",
    [salonOptions, form.salonId]
  );

  const kod = form.standCode.trim();
  const requiredValid = !!fuarId && kod !== "" && form.salonId !== "" && !!katilimciFirma;
  // Salon listesi yoksa hol adını BİLMİYORUZ — ön izlemede yalnız kodu göster, adı uydurma.
  const previewName = salonName ? composeStandName(salonName, kod) : kod;

  async function handleSubmit() {
    if (!requiredValid || submitting) return;
    setSubmitting(true);
    setError(null);
    setKodCakisti(false);
    try {
      const createRes = await createStand(
        { standCode: kod, fuarId, salonId: Number(form.salonId), salonName },
        { forceLive }
      );
      const standId = createRes.standId;
      // Tabela adı create gövdesinde YOK — ayrı bir PUT gerekiyor. Boşsa anahtarı
      // hiç göndermiyoruz (containsKey semantiği: boş string "SİL" demek).
      if (form.tabelaAdi.trim() !== "") {
        await updateStand(standId, { tabelaAdi: form.tabelaAdi.trim() }, { forceLive });
      }
      await assignFirmaToStand(standId, {
        firmaId: katilimciFirma.firmaId, firmaTypeId: FIRMA_TYPE.KATILIMCI, fuarId,
      }, { forceLive });
      if (dekoratorFirma) {
        await assignFirmaToStand(standId, {
          firmaId: dekoratorFirma.firmaId, firmaTypeId: FIRMA_TYPE.DEKORATOR, fuarId,
        }, { forceLive });
      }
      if (form.standTypeId !== "") {
        await createProject({
          standId, firmaId: katilimciFirma.firmaId, fuarId,
          dekoratorFirmaId: dekoratorFirma ? dekoratorFirma.firmaId : null,
          standTypeId: Number(form.standTypeId),
        }, { forceLive });
      }
      // Adı biz seçmedik, hol seçti — yanıttaki adı kullan, yeniden türetme.
      setCreated({ standId, standName: createRes.standName || `#${standId}` });
    } catch (e) {
      setKodCakisti(isStandAdiCakismasi(e));
      setError(e?.response?.data?.message || e?.message || tx("standYarat.standOlusturulamadi"));
    } finally {
      setSubmitting(false);
    }
  }

  function handleReset() {
    setKodCakisti(false);
    setForm(EMPTY_FORM);
    setKatilimciFirma(null);
    setDekoratorSecim(undefined); // öneriye geri dön
    setCreated(null);
    setError(null);
  }

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={tx("standYarat.standYarat")} pageTitle={tx("standYarat.standlar")} />

        <Row className="justify-content-center">
          <Col xxl={8} xl={10}>
            {!fuarId && (
              <Alert color="warning" className="py-2">{tx("standYarat.ustCubuktanBirFuarSecin")}</Alert>
            )}
            {error && <Alert color="danger" className="py-2">{error}</Alert>}

            {created ? (
              <Card>
                <CardBody className="text-center py-4">
                  <i className="bx bx-check-circle text-success display-6" />
                  <h5 className="mt-2 mb-1">{created.standName}{" "}{tx("standYarat.olusturuldu")}</h5>
                  <p className="text-muted small mb-3">{tx("standYarat.standId")}{created.standId}</p>
                  <div className="d-flex justify-content-center flex-wrap gap-2">
                    <Button
                      color="primary" size="sm"
                      onClick={() => navigate(`${LIST_PATH}/${created.standId}`)}
                    >
                      {tx("standYarat.standDetayinaGit")}
                    </Button>
                    <Button color="light" size="sm" onClick={handleReset}>
                      <i className="bx bx-plus me-1" />{tx("standYarat.birTaneDaha")}
                    </Button>
                    <Button color="light" size="sm" tag={Link} to={LIST_PATH}>{tx("standYarat.standlar")}</Button>
                  </div>
                </CardBody>
              </Card>
            ) : (
              <Card>
                <CardHeader className="d-flex align-items-center gap-2 py-2">
                  <h6 className="card-title mb-0 flex-grow-1">{tx("standYarat.yeniStand")}</h6>
                  {fuarId && <Badge color="light" className="text-body">{tx("standYarat.fuar")}{fuarId}</Badge>}
                  {fuarId && !forceLive && (
                    <Badge color="warning" title={tx("standYarat.canliTestFuarlari298299")}>
                      {tx("standYarat.mock")}
                    </Badge>
                  )}
                </CardHeader>

                <CardBody>
                  <Row className="g-3">
                    <Col md={6}>
                      <FirmaSearchSelect
                        label={<>{tx("standYarat.katilimciFirma")}{" "}<span className="text-danger">*</span></>}
                        value={katilimciFirma}
                        onChange={handleKatilimciChange}
                        onCreateNew={() => setCreateFirmaFor("katilimci")}
                        forceLive={forceLive}
                        disabled={submitting}
                      />
                    </Col>
                    <Col md={6}>
                      <FirmaSearchSelect
                        label={tx("standYarat.dekoratorFirma")}
                        value={dekoratorFirma}
                        onChange={setDekoratorSecim}
                        onCreateNew={() => setCreateFirmaFor("dekorator")}
                        forceLive={forceLive}
                        disabled={submitting}
                      />
                    </Col>
                  </Row>

                  <hr className="my-3 border-dashed" />

                  <StandIdentityFields
                    compact
                    form={form}
                    update={update}
                    salonOptions={salonOptions}
                    salonsUnavailable={salonsLoaded && salonOptions.length === 0}
                    disabled={submitting}
                    codeInvalid={kodCakisti}
                  />

                  {rootTypes.length > 0 && (
                    <div className="mt-3">
                      <Label size="sm" className="d-block pt-0">
                        {tx("standYarat.standTuru")}{" "}<span className="text-muted fw-normal">{tx("standYarat.secilirseProjeKaydiDaAcilir")}</span>
                      </Label>
                      <StandTypeRows
                        grouped
                        options={rootTypes}
                        renderOption={(t, faded) => {
                          const selected = form.standTypeId === String(t.stand_type_id);
                          return (
                            <Button
                              key={t.stand_type_id} type="button" color="primary" outline={!selected}
                              className={faded && !selected ? "opacity-50" : undefined}
                              disabled={submitting}
                              onClick={() => update({ standTypeId: selected ? "" : String(t.stand_type_id) })}
                            >
                              {/* Ham ad: kök listesi iki paralel ağaçtan geliyor; " (n)" işareti
                                  yeni ağacın etiketinde kalır (üst satır yeni, alt satır eski). */}
                              {t.stand_type_name}
                            </Button>
                          );
                        }}
                      />
                    </div>
                  )}
                </CardBody>

                <CardFooter className="d-flex align-items-center flex-wrap gap-2 py-2">
                  <span className="small text-muted">
                    {tx("standYarat.standAdi")}{" "}<strong className="text-body">{previewName || "—"}</strong>
                  </span>
                  <div className="ms-auto d-flex gap-2">
                    <Button color="light" size="sm" tag={Link} to={LIST_PATH}>{tx("common:iptal")}</Button>
                    <Button color="success" size="sm" onClick={handleSubmit} disabled={!requiredValid || submitting}>
                      {submitting ? <Spinner size="sm" className="me-1" /> : <i className="bx bx-plus me-1" />}
                      {tx("standYarat.standiOlustur")}
                    </Button>
                  </div>
                </CardFooter>
              </Card>
            )}
          </Col>
        </Row>
      </Container>

      <CreateFirmaModal
        key={createFirmaFor || "closed"}
        isOpen={createFirmaFor !== null}
        onClose={() => setCreateFirmaFor(null)}
        fuarId={fuarId}
        forceLive={forceLive}
        defaultRoleId={createFirmaFor === "dekorator" ? FIRMA_TYPE.DEKORATOR : FIRMA_TYPE.KATILIMCI}
        onCreated={(firma) => {
          if (createFirmaFor === "dekorator") setDekoratorSecim(firma);
          else handleKatilimciChange(firma);
          setCreateFirmaFor(null);
        }}
      />
    </div>
  );
}
